import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const items = ['Guía Maestra Método "Caja de Oro" (PDF detallado paso a paso).', 'El Sistema de Fotos "Imán" para resaltar sobre la competencia.', 'Guion de Messenger: Qué responder para cerrar la venta rápido.', 'Checklist de Inspección: Cómo saber si una caja vale la pena antes de pagarla.', 'Directorio de Liquidadores: Dónde comprar mercancía real en tu zona.'];
  return <section className="w-full bg-slate-800 py-16 md:py-24" data-id="element-175">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-178">
            Esto es lo que recibirás hoy
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-179">
            Todo lo que necesitas para empezar tu negocio este mismo fin de
            semana
          </p>
        </motion.div>

        <div className="bg-slate-900 rounded-2xl p-8 md:p-10 border border-slate-700 shadow-xl" data-id="element-180">
          <ul className="space-y-6" data-id="element-181">
            {items.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-182">
                <CheckCircle2 className="w-6 h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-183" />
                <span className="text-lg text-slate-200" data-id="element-184">{item}</span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}